import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewEncapsulation,
	ElementRef, QueryList, ViewChildren } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, FormsModule, ReactiveFormsModule, Validators }
	from '@angular/forms';
import moment from 'moment';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@copo/mat-datepicker-new';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgIf, NgFor, NgClass, DecimalPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { UNDERSCORE } from '../../../../shared/utils/constant';
import { FastLaneWizardStep } from '../../../models/fastlane-wizard-state';
import { FormFastLane } from '../../../models/form-fastlane';
import { FastLaneWizardStepperService } from '../../../services/fastlane-wizard-stepper.service';
import { FastLaneWizardService } from '../../../services/fastlane-wizard.service';
import { FastLaneService } from '../../../services/fastlane.service';
import { FORM_SHEET, plant, rddTypes, transportMode, SHIP_TO_CUSTOM,
	units, formValues, SHIP_TO_LATER } from '../../../models/fastlane-list';
import { WizardPageContent } from '../wizard-page-content';
import { ErrorService } from '../../../../shared/services/error.service';
import { TranslationService } from '../../../../shared/services/translation.service';
import { CopoDatepickerInputDirective } from '../../../../shared/directives/date-picker.directive';
import { SafeUrlPipe } from '../../../../shared/pipes/safeurl.pipe';
import { FastLaneRequestAttachment, FastLaneRequestAttachmentForm } from '../../../models/fastlane.model';
import { CodeValue } from '../../../../shared/models/boc-available-value';
import { UserService } from '../../../../shared/services/user.service';
import { BocClient } from '../../../../shared/models/boc-client-transac';
import { SoldToRelationshipGroup } from '../../../../shared/models/service';
import { SortOptionsPipe } from '../../../../shared/pipes/sorting.pipe';

@Component({
	selector: 'copo-step-transport',
	templateUrl: './step-transport.component.html',
	styleUrl: './step-transport.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		TranslateModule,
		NgIf,

		MatTooltipModule,
		FormsModule,
		ReactiveFormsModule,
		NgFor,
		NgClass,
		MatExpansionModule,

		MatFormFieldModule,

		MatSelectModule,

		MatOptionModule,

		MatButtonModule,
		MatIconModule,

		MatInputModule,
		CopoDatepickerInputDirective,
		MatDatepickerModule,
		MatDividerModule,
		DecimalPipe,
		SafeUrlPipe,
		SortOptionsPipe
	],
})

export class StepTransportComponent extends WizardPageContent implements OnInit, AfterViewInit {
	@ViewChildren('rows') rows!: QueryList<ElementRef<HTMLElement>>;

	readonly form: FormFastLane;
	productFormGroup!: FormGroup;
	readonly UNDERSCORE = UNDERSCORE;
	incotList?: CodeValue[];
	soldto?: string;
	description?: string | undefined;
	shipto = '';
	shipToCustom = '';
	shipToPerson = '';
	shipToContact = '';
	customDestination = '';
	bocs?: Map<string, BocClient>;
	shipToList?: BocClient[];
	userBocData?: SoldToRelationshipGroup[];
	requestName?: string | undefined;
	calStartDate!: Date;
	calEndDate!: Date;
	transportModeInitselected = 'None';
	incotermInitselected = 'None';
	config = { codeProp: 'value', valueProp: 'display' };
	configForIncotList = { codeProp: 'description', valueProp: 'code' };
	configForPlant = { codeProp: 'code', valueProp: 'value' };
	configForBoc = { codeProp: 'businessId', valueProp: 'name' };

	private readonly VIEW_STEP_NUM = 2;

	constructor(
		public fb: FormBuilder,
		private readonly fastlaneWizardService: FastLaneWizardService,
		private readonly fastlaneStepperService: FastLaneWizardStepperService,
		private readonly userService: UserService,
		private readonly fastlaneService: FastLaneService,
		public changeDetectorRef: ChangeDetectorRef,
		private readonly errorService: ErrorService,
		private readonly translationService: TranslationService
	) {
		super(FastLaneWizardStep.TRANSPORTDETAILS, fastlaneWizardService.getState());
		this.form = this.fastlaneWizardService.getStateFastLaneForm();
		this.initializeProductSpecifications();
		this.setCalendarStartEndDate();
		this.incotList = this.bocAvailableValues('INCOT');
	}

	get productResultControl() {
		return (<FormArray> this.productFormGroup.controls['productSpecifications']).controls;
	}

	get productFormArray() {
		return <FormArray> this.productFormGroup.get('productSpecifications');
	}

	getItemName(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('name');
		return <string>fieldControl.value;
	}

	getSteelGrade(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('steelgrade');
		return <string>fieldControl.value;
	}

	getTooltipDescriptionText(tooltipText: string) {
		if (tooltipText && tooltipText.length > 40) {
			const textArray = tooltipText.match(/.{1,40}/g);
			return textArray ? textArray.join('\n') : tooltipText;
		}
		return tooltipText;
	}

	getCustomShipToTooltipText() {
		let responseText;
		if (this.shipToCustom && this.shipToCustom.length > 40) {
			const textArray = this.shipToCustom.match(/.{1,40}/g);
			responseText = textArray ? textArray.join('\n') : this.shipToCustom;
		} else {
			responseText = this.shipToCustom;
		}
		if (this.shipToPerson && this.shipToPerson.length > 40) {
			const textArray = this.shipToPerson.match(/.{1,40}/g);
			responseText = `${ responseText } \n ${ textArray ? textArray.join('\n') : this.shipToPerson }`;
		} else {
			responseText = `${ responseText } \n ${ this.shipToPerson }`;
		}
		if (this.shipToContact && this.shipToContact.length > 40) {
			const textArray = this.shipToContact.match(/.{1,40}/g);
			responseText = `${ responseText } \n ${ textArray ? textArray.join('\n') : this.shipToContact } `;
		} else {
			responseText = `${ responseText } \n ${ this.shipToContact }`;
		}
		return responseText;
	}

	getOrderTrackingForm(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl> controlArray.controls[formIndex].get('form');
		return this.translationService.getTR(this.getTranslationKey(<string>fieldControl.value, formValues));
	}

	getThickness(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('thickness');
		return <string>fieldControl.value;
	}

	getWidth(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('width');
		return <string>fieldControl.value;
	}

	getLength(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('length');
		return <string>fieldControl.value;
	}

	getFormBlank(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('blankWeight');
		return <string>fieldControl.value;
	}

	getQuantity(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('quantity');
		return <string>fieldControl.value;
	}

	getUnit(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('quantityUnit');
		return this.translationService.getTR(this.getTranslationKey(<string>fieldControl.value, units));
	}

	getTranslationKey(code: string, arr: { value: string; display: string }[]) {
		const translationObj = arr.find(item => item.value === code);
		return translationObj ? translationObj.display : '';
	}

	onSelectChange(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('rddDate');
		if (fieldControl.value && fieldControl.value !== null
		) {
			const rddValue = moment(<Date>fieldControl.value);
			fieldControl.setValue(rddValue.day(5).toDate());
		}
	}

	getRddType(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const rddTypeControl = <FormControl> controlArray.controls[formIndex].get('rddType');
		return <string>rddTypeControl.value;
	}

	compareWithFn(field1: string, field2: string) {
		return field1 === field2;
	}

	setCalendarStartEndDate() {
		const date = new Date();
		const calStartDate = new Date();
		if ((11 - date.getMonth()) < 6) {
			calStartDate.setMonth(calStartDate.getMonth() - 6);
		} else {
			calStartDate.setMonth(calStartDate.getMonth() + 6);
			calStartDate.setFullYear(calStartDate.getFullYear() - 1);
		}

		if ((calStartDate.getMonth() === 1)
			&& ((calStartDate.getDate() === 29)
				|| (calStartDate.getDate() === 30)
				|| (calStartDate.getDate() === 31))) {
			if (this.isLeapYear(calStartDate.getFullYear())) {
				calStartDate.setDate(29);
			} else {
				calStartDate.setDate(28);
			}
		}
		const calEndDate = new Date();
		calEndDate.setFullYear(calEndDate.getFullYear() + 2);
		this.calStartDate = calStartDate;
		this.calEndDate = calEndDate;
	}

	isLeapYear(year: number) {
		return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
	}

	initializeProductSpecifications() {
		if (this.fastlaneService.productFormGroup) {
			this.productFormGroup = this.fastlaneService.productFormGroup;
			this.markAsUntouched();
		} else {
			this.productFormGroup = new FormGroup({
				productSpecifications: new FormArray([]),
			});
			this.fastlaneService.productFormGroup = this.productFormGroup;
		}
	}

	hasRequestAttachments() {
		const attachmentFormGroups = <FormArray> this.form.get('fastLaneAttachments');
		return attachmentFormGroups.length > 0;
	}

	getRequestAttachments() {
		const attachmentFormGroups = <FormArray> this.form.get('fastLaneAttachments');
		const attachments: FastLaneRequestAttachment[] = [];
		for (const itemRow of attachmentFormGroups.value) {
			const fastLaneAttachment = (<FastLaneRequestAttachmentForm>
				itemRow).fastlaneAttachment;
			attachments.push(fastLaneAttachment);
		}
		return attachments;
	}

	ngOnInit(): void {
		const soldtoShiptoList = this.fastlaneService.filteredSoldtoShiptoList;
		const selSoldtoId = <string> this.form.getFormSoldTo().value;
		const selShiptoId = <string> this.form.getFormShipTo().value;
		this.description = <string> this.form.getFormDescription().value;
		this.requestName = <string> this.form.getFormCustomerRequestName().value;
		this.shipToList = this.fastlaneService.filterShiptoList;
		if (selShiptoId === SHIP_TO_LATER) {
			this.shipto = this.translationService.getTR('fastlane.wizard.decide.later');
		} else if (selShiptoId === SHIP_TO_CUSTOM) {
			this.shipToCustom = <string> this.form.getFormShipToCustom().value;
			this.shipToPerson = <string> this.form.getFormShipToPerson().value;
			this.shipToContact = <string> this.form.getFormShipToContact().value;
			this.customDestination = `${ this.shipToCustom } ${ this.shipToPerson } ${ this.shipToContact }`;
			this.shipto = this.translationService.getTR('fastlane.wizard.custom.destination');
		} else if (this.shipToList) {
			for (const shipTo of this.shipToList) {
				if (shipTo.businessId === selShiptoId) {
					this.shipto = `${ shipTo.name } - ${ shipTo.city }`;
				}
			}
		}
		if (soldtoShiptoList) {
			const selectedSoldtoList = soldtoShiptoList.filter(v => v.businessId === selSoldtoId);
			for (const soldtoList of selectedSoldtoList) {
				this.soldto = `${ soldtoList.name } - ${ soldtoList.city }`;
			}
		}
		this.fastlaneStepperService.onStepChanged.emit({ step: this.VIEW_STEP_NUM });
		this.errorService.resetErrorMsg();
	}

	ngAfterViewInit() {
		this.changeDetectorRef.detectChanges();
	}

	checkError(): boolean {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		let indexToScroll = -1;
		let i = 0;
		for (const control of controlArray.controls) {
			this.checkRddFormFields(<FormGroup> control);
			if (control.invalid) {
				control.markAllAsTouched();
				control.updateValueAndValidity();
				if (indexToScroll === -1) {
					indexToScroll = i;
				}
			}
			i++;
		}
		const rowItems = this.rows.toArray();
		if (indexToScroll !== -1) {
			if (rowItems[indexToScroll]) {
				rowItems[indexToScroll].nativeElement.scrollIntoView();
			}
			return true;
		}
		return false;
	}

	checkRddFormFields(formGroup: FormGroup): void {
		for (const key of Object.keys(formGroup.controls)) {
			if (key === 'rddDate' && formGroup.get(key)?.value === '') {
				this.form.patchValue({ rddDate: null });
				formGroup.get(key)?.setErrors(null);
			}
		}
	}

	markAsUntouched() {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		for (const control of controlArray.controls) {
			control.markAsUntouched();
		}
	}

	geterror(formIndex: number, controlName: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get(controlName);
		return Boolean(fieldControl.errors?.['required'] && fieldControl.touched);
	}

	getRdd() {
		return rddTypes;
	}

	getPlant() {
		return plant;
	}

	getTransportMode() {
		return transportMode;
	}

	isSheetSelected(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('form');
		return fieldControl.value === FORM_SHEET;
	}

	onChangeShipTo(i: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[i].get('shipTo');
		const newBoc = {
			soldTo: <string | undefined> this.form.getFormSoldTo().value,
			shipTo: <string | undefined> fieldControl.value
		};
		const lastBoc = this.form.getAndUpdateLastBoc(newBoc);
		if (
			(
				lastBoc.soldTo !== undefined
				&& newBoc.soldTo !== undefined
				&& lastBoc.soldTo !== newBoc.soldTo
			)
			|| (
				lastBoc.shipTo !== undefined
				&& newBoc.shipTo !== undefined
				&& lastBoc.shipTo !== newBoc.shipTo
			)
		) {
			this.form.getAndUpdateLastBoc(lastBoc);
			this.form.getFormSoldTo().setValue(lastBoc.soldTo, { emitEvent: false });
			this.form.getFormShipTo().setValue(lastBoc.shipTo, { emitEvent: false });
		}
		if (newBoc.shipTo) {
			this.updateShipToValidators(newBoc.shipTo, i);
		}
	}

	updateShipToValidators(shipToValue: string, i: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		if (shipToValue === SHIP_TO_CUSTOM) {
			controlArray.controls[i].get('shipToPerson')?.setValue('N/A');
			controlArray.controls[i].get('shipToContact')?.setValue('N/A');
			controlArray.controls[i].get('shipToCustom')?.setValidators([Validators.required]);
			controlArray.controls[i].get('shipToCustom')?.updateValueAndValidity();
			controlArray.controls[i].get('shipToPerson')?.setValidators([Validators.required]);
			controlArray.controls[i].get('shipToPerson')?.updateValueAndValidity();
			controlArray.controls[i].get('shipToContact')?.setValidators([Validators.required]);
			controlArray.controls[i].get('shipToContact')?.updateValueAndValidity();
		} else {
			controlArray.controls[i].get('shipToCustom')?.setValidators([]);
			controlArray.controls[i].get('shipToCustom')?.updateValueAndValidity();
			controlArray.controls[i].get('shipToPerson')?.setValidators([]);
			controlArray.controls[i].get('shipToPerson')?.updateValueAndValidity();
			controlArray.controls[i].get('shipToContact')?.setValidators([]);
			controlArray.controls[i].get('shipToContact')?.updateValueAndValidity();
		}
	}

	getShipToType(i: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[i].get('shipTo');
		return <string | undefined>fieldControl.value;
	}

	private bocAvailableValues(parameter: string) {
		return this.userService.getBocAvailableValuesBasedOnCode('PFAST', parameter);
	}
}
